import { EXPORT_SUCCESS_TAG } from "../helpers/exportFlow";
import { translate } from "app/filters/i18nFilter";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import { exportToCrmToastThunk } from "../../management/store/effects/common";
import type { ExportContactsToCrmResponseDto } from "../types/dto";

import { selectExportMessageTranslationKeys } from "./selectors";

function showExportContactsToCrmSuccessThunk(exportHistoryUrl?: string) {
    return function (dispatch: ThunkDispatchCommon, getState: ThunkGetState) {
        const { crmName, keyBase } = selectExportMessageTranslationKeys(getState());
        const text = translate(`${keyBase}.success`, { crmName });
        dispatch(exportToCrmToastThunk(text, exportHistoryUrl, EXPORT_SUCCESS_TAG));
    };
}

export function showExportContactsToCrmFailureThunk(exportHistoryUrl?: string) {
    return function (dispatch: ThunkDispatchCommon, getState: ThunkGetState) {
        const { crmName, keyBase } = selectExportMessageTranslationKeys(getState());
        const text = translate(`${keyBase}.failure`, { crmName });
        dispatch(exportToCrmToastThunk(text, exportHistoryUrl));
    };
}

function showExportContactsToCrmPartialThunk({
    processedRecords,
    contactsCount,
    exportHistoryUrl,
}: {
    processedRecords: number;
    contactsCount: number;
    exportHistoryUrl?: string;
}) {
    return function (dispatch: ThunkDispatchCommon, getState: ThunkGetState) {
        const { crmName, keyBase } = selectExportMessageTranslationKeys(getState());
        const remainingCount = contactsCount - processedRecords;
        const replacements = {
            crmName,
            exportedCount: processedRecords,
            contactsCount,
            remainingCount,
        };
        const text = translate(`${keyBase}.partial`, replacements);
        dispatch(exportToCrmToastThunk(text, exportHistoryUrl, EXPORT_SUCCESS_TAG));
    };
}

export function showExportContactsToCrmFinishedThunk({
    response,
    contactsCount,
}: {
    response: ExportContactsToCrmResponseDto | undefined;
    contactsCount?: number;
}) {
    return function (dispatch: ThunkDispatchCommon) {
        if (!response) {
            dispatch(showExportContactsToCrmFailureThunk());
            return;
        }
        const { processedRecords, failedRecords = 0, inProgressRecords = 0, exportHistoryUrl } = response;

        if (inProgressRecords > 0) {
            return;
        }

        if (failedRecords > 0 && processedRecords === 0) {
            dispatch(showExportContactsToCrmFailureThunk(exportHistoryUrl));
        } else if (contactsCount && processedRecords && processedRecords < contactsCount) {
            dispatch(
                showExportContactsToCrmPartialThunk({
                    processedRecords,
                    contactsCount,
                    exportHistoryUrl,
                }),
            );
        } else {
            dispatch(showExportContactsToCrmSuccessThunk(exportHistoryUrl));
        }
    };
}
